<template>
	<component
		:is="activityComponent"
		:activity="activity"
		@click="onClick"
	/>
</template>

<script>
import { GoalActivityType, KeyResultActivityType } from "@teaming/common-enums";

import GoalArchiveActivity from "./GoalArchiveActivity.vue";
import GoalCommentActivity from "./GoalCommentActivity.vue";
import GoalConfidenceActivity from "./GoalConfidenceActivity.vue";
import GoalCreationActivity from "./GoalCreationActivity.vue";
import GoalDueDateActivity from "./GoalDueDateActivity.vue";
import GoalFinishDateActivity from "./GoalFinishDateActivity.vue";
import GoalKRCommentActivity from "./GoalKRCommentActivity.vue";
import GoalKRConfidenceActivity from "./GoalKRConfidenceActivity.vue";
import GoalKRCreationActivity from "./GoalKRCreationActivity.vue";
import GoalKRNameActivity from "./GoalKRNameActivity.vue";
import GoalKROwnerActivity from "./GoalKROwnerActivity.vue";
import GoalKRProgressActivity from "./GoalKRProgressActivity.vue";
import GoalKRSortOrderActivity from "./GoalKRSortOrderActivity.vue";
import GoalKRTypeActivity from "./GoalKRTypeActivity.vue";
import GoalStartDateActivity from "./GoalStartDateActivity.vue";
import GoalTeamActivity from "./GoalTeamActivity.vue";
import GoalTitleActivity from "./GoalTitleActivity.vue";
import UnknownActivity from "../Activity/UnknownActivity.vue";

const componentMap = {
	GOAL: {
		[ GoalActivityType.ARCHIVED ]: "GoalArchiveActivity",
		[ GoalActivityType.COMMENT ]: "GoalCommentActivity",
		[ GoalActivityType.CONFIDENCE ]: "GoalConfidenceActivity",
		[ GoalActivityType.CREATE ]: "GoalCreationActivity",
		[ GoalActivityType.DUE_DATE ]: "GoalDueDateActivity",
		[ GoalActivityType.FINISH_DATE ]: "GoalFinishDateActivity",
		[ GoalActivityType.START_DATE ]: "GoalStartDateActivity",
		[ GoalActivityType.TEAM ]: "GoalTeamActivity",
		[ GoalActivityType.TITLE ]: "GoalTitleActivity",
	},
	KEY_RESULT: {
		[ KeyResultActivityType.COMMENT ]: "GoalKRCommentActivity",
		[ KeyResultActivityType.CONFIDENCE ]: "GoalKRConfidenceActivity",
		[ KeyResultActivityType.CREATE ]: "GoalKRCreationActivity",
		[ KeyResultActivityType.NAME ]: "GoalKRNameActivity",
		[ KeyResultActivityType.OWNER ]: "GoalKROwnerActivity",
		[ KeyResultActivityType.PROGRESS ]: "GoalKRProgressActivity",
		[ KeyResultActivityType.SORT_ORDER ]: "GoalKRSortOrderActivity",
		[ KeyResultActivityType.TYPE ]: "GoalKRTypeActivity",
	},
};

/**
 * Meta-component for activity entries.
 */
export default {
	name: "GoalActivity",
	emits: [ "action", ],
	components: {
		GoalArchiveActivity,
		GoalCommentActivity,
		GoalConfidenceActivity,
		GoalCreationActivity,
		GoalDueDateActivity,
		GoalFinishDateActivity,
		GoalKRCommentActivity,
		GoalKRConfidenceActivity,
		GoalKRCreationActivity,
		GoalKRNameActivity,
		GoalKROwnerActivity,
		GoalKRProgressActivity,
		GoalKRSortOrderActivity,
		GoalKRTypeActivity,
		GoalStartDateActivity,
		GoalTeamActivity,
		GoalTitleActivity,
		UnknownActivity,
	},
	props: {
		activity: {
			type: Object,
			required: true,
			validator( activity ) {
				const { discriminator = "", activityType = "", } = activity;
				if ( ![ "GOAL", "KEY_RESULT", ].includes( discriminator ) ) {
					return false;
				}
				if ( discriminator === "GOAL" ) {
					return GoalActivityType.includes( activityType );
				}
				if ( discriminator === "KEY_RESULT" ) {
					return KeyResultActivityType.includes( activityType );
				}
				return false;
			},
		},
	},
	computed: {
		activityComponent() {
			const { discriminator, activityType, } = this.activity;
			return componentMap?.[ discriminator ]?.[ activityType ] || "UnknownActivity";
		},
	},
	methods: {
		onClick( e ) {
			const { activity, } = this;
			const { action, } = e.target.dataset;
			if ( action ) {
				this.$emit( "action", { action, activity, } );
				e.preventDefault();
				e.stopPropagation();
			}
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
